import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { FilterGlobalResponseModel } from 'src/app/models/responses/filter-global-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EquipmentAvailabilityService {

  constructor(private _httpClient: HttpClient) { }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean, orderTypeId: number): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString()).set('orderTypeId', orderTypeId);
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.equipmentAvailability.ExportGeneralConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  getAllEquipmentAvailabilityWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[], orderTypeId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('orderTypeId', orderTypeId);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.equipmentAvailability.GetAllEquipmentAvailabilityWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForGeneralConsultation(): Observable<FilterGlobalResponseModel> {
    return this._httpClient.get<FilterGlobalResponseModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.equipmentAvailability.GetColumnsForGeneralConsultationAsync}`);
  }
}
